import useQueryVendorsByType from '@hooks/networkElements/useQueryVendorsByType';

import { IAlarmFilter } from '@interfaces/alarms/alarm';
import { IOrganizationId } from '@interfaces/common/common';

import useQueryNetworkElementsEventTypes from './useQueryNetworkElementsEventTypes';
import useQueryNetworkElementsNames from './useQueryNetworkElementsNames';

interface IUseNetworkElementsConnectionLogsFilters {
	connectionLogsFiltersList: IAlarmFilter[];
	isLoadingConnectionLogsFilters: boolean;
}

export const useNetworkElementsConnectionLogsFilters = (
	params: Partial<IOrganizationId>,
): IUseNetworkElementsConnectionLogsFilters => {
	const { vendorOptions, isLoadingVendorOptions } = useQueryVendorsByType();
	const { namesOptions, isLoadingNamesOptions } = useQueryNetworkElementsNames(params);
	const { eventTypesOptions, isLoadingEventTypesOptions } = useQueryNetworkElementsEventTypes(params);

	const connectionLogsFiltersList = [
		{
			name: 'eventType',
			placeholder: 'Event Type',
			data: eventTypesOptions,
		},
		{
			name: 'networkElementName',
			placeholder: 'Name',
			data: namesOptions,
		},
		{
			name: 'vendor',
			placeholder: 'Vendor',
			data: vendorOptions,
		},
	];

	return {
		connectionLogsFiltersList,
		isLoadingConnectionLogsFilters: isLoadingNamesOptions ||
			isLoadingVendorOptions ||
			isLoadingEventTypesOptions,
	};
};
